module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-1 col-sm-10 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("立即填寫表單，成為聯盟商城的一份子")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("登入表單")]), _vm._v(" "), _c('div', {
    staticClass: "apply_form"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputCo"
    }
  }, [_vm._v("公司/店面名稱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_name),
      expression: "com_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面名稱",
      "required": ""
    },
    domProps: {
      "value": (_vm.com_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputCoPhone"
    }
  }, [_vm._v("公司電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_phone),
      expression: "com_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "公司電話"
    },
    domProps: {
      "value": (_vm.com_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_phone = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countyval),
      expression: "countyval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countyval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.county), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                    " + _vm._s(option.text) + "\n                                                ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtval),
      expression: "districtval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.districtval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.district), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                    " + _vm._s(option.text) + "\n                                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "公司/店面地址"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "inputUrl"
    }
  }, [_vm._v("網址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.com_site),
      expression: "com_site"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "官方網址"
    },
    domProps: {
      "value": (_vm.com_site)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.com_site = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConName"
    }
  }, [_vm._v("聯絡人姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_name),
      expression: "contact_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "聯絡人姓名",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("聯絡人手機")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_phone),
      expression: "contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "聯絡人手機",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("聯絡人信箱(帳號)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "聯絡人信箱",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "maxlength": "20",
      "placeholder": "請輸入您想要的密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("負責人會員編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reliablemanid),
      expression: "reliablemanid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "負責人會員編號",
      "required": ""
    },
    domProps: {
      "value": (_vm.reliablemanid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reliablemanid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label input_required",
    attrs: {
      "for": "inputConPhone"
    }
  }, [_vm._v("商品類別")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategory),
      expression: "productCategory"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "填寫商品類別",
      "required": ""
    },
    domProps: {
      "value": (_vm.productCategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productCategory = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.i_read_agreement),
      expression: "i_read_agreement"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.i_read_agreement) ? _vm._i(_vm.i_read_agreement, null) > -1 : (_vm.i_read_agreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.i_read_agreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.i_read_agreement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.i_read_agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.i_read_agreement = $$c
        }
      }
    }
  }), _vm._v("\n                                  「我已詳細閱讀 "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/static/files/agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("聯盟合約")]), _vm._v(" 內容」\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.apply()
      }
    }
  }, [_vm._v("確認申請")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("加入聯盟")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("填寫表單")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "editor"
  }, [_vm._v("\n                        現在愛幫您平台讓您能夠與我們一同合作擴大消費市場，加入之後您可以體驗我們的網站及 APP 的服務支援，\n                        並將商品推廣給我們的平台會員，讓您的商品快速擴展於平台。"), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                        接下來需要您先填寫貴公司相關的資料表格，系統將會為您建立一組登入帳號，方便您進入我們的管理平台，以及請閱讀相關合約「\n                        "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/static/files/agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("聯盟合約下載")]), _vm._v("」\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a784cd0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FreeTrial.vue
// module id = 316
// module chunks = 1